import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { getStrapiMedia } from "../../utils/utils";
import "./HomepagePartners.scss";
import { LinWithIconComponent_Plain } from "../../types/components/shared/LinWithIconComponent.ts";

const HomepagePartners = ({ data }: { data: LinWithIconComponent_Plain[] }) => {
  const swiperRef = useRef(null);

  return (
    <section className="line-partners">
      <Swiper
        ref={swiperRef}
        modules={[Autoplay, Navigation]}
        spaceBetween={10}
        slidesPerView={5}
        loop={true}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
        }}
        speed={2000}
        breakpoints={{
          767: { spaceBetween: 20, slidesPerView: 10 },
          991: { spaceBetween: 25, slidesPerView: 12 },
          1250: { spaceBetween: 30, slidesPerView: 15 },
        }}
        className="line-partners-list"
      >
        {data.map((item, i: number) => (
          <SwiperSlide key={i}>
            <div className="line-partners-list__item">
              {item.icon ? (
                <img
                  src={getStrapiMedia(item.icon.url)}
                  height="36"
                  alt={item.title || `Partner logo ${i}`}
                />
              ) : null}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default HomepagePartners;
